import {
  fetch,
  normalize,
  extractHubURL
} from '../../utils/dataAccess';
import filterStorage from "../../utils/filtersStorage";
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'EMAILTEMPLATE_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'EMAILTEMPLATE_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'EMAILTEMPLATE_LIST_SUCCESS', retrieved };
}

export function list(page = 'emails') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'EMAILTEMPLATE_LIST_RESET' });
  };
}

export function filter(filtersData) {
  return filterAction('EMAILTEMPLATE_LIST_FILTER', 'emails', filtersData)
}

export function sort(sortData) {
  return sortAction('EMAILTEMPLATE_LIST_SORT','emails', sortData)
}
